/**
 * @fileoverview Centralized configuration for enabling/disabling tracking platforms.
 * @module trackingFlags
 *
 * This file allows toggling individual tracking platforms globally.
 * It is used across ClientTrackerManager, ServerTrackerManager, and DataManager.
 */

/**
 * Centralized tracking flags.
 * Toggle each platform ON or OFF.
 */
export const TRACKERS = {
    /**
     * Enable/disable Google Analytics tracking
     * @type {boolean}
     */
    GOOGLE: true,
  
    /**
     * Enable/disable Facebook Pixel tracking
     * @type {boolean}
     */
    FACEBOOK: false,
  
    /**
     * Enable/disable TikTok Pixel tracking
     * @type {boolean}
     */
    TIKTOK: false,
  
    /**
     * Enable/disable Pinterest tracking
     * @type {boolean}
     */
    PINTEREST: false,
  
    /**
     * Enable/disable InMarket tracking
     * @type {boolean}
     */
    INMARKET: false,
  
    /**
     * Enable/disable all server-side tracking
     * @type {boolean}
     */
    SERVER_TRACKING: false,
  };
  